module.exports = __webpack_public_path__ + "static/media/planetTexture1.7b607a5f.jpeg";